import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
          This page has not been generated
        </h1>
        <p className="mt-4 text-lg text-foreground-500">Tell me more about this page, so I can generate it</p>
        <Link
          to="/en"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}